import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";

import {
  convertTimestamp,
  convertTimestampsPipe,
} from "../../@core/utils/convertTimestamps.service";
import { Subject } from "rxjs";
import Exercise from "../../models/exercise.model";
import { ExerciseService } from "../../services/exercise.service";
import { SectionLecture } from "../../models/course-content.model";

@Component({
  selector: "ngx-dialog-do-exercise",
  templateUrl: "dialog-do-exercise.component.html",
  styleUrls: ["dialog-do-exercise.component.scss"],
})
export class DialogDoExerciseComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header?: string;
  @Input() linkExerciseId?: string;
  @Input() courseLecture?: SectionLecture;

  exercise: Exercise = new Exercise();

  maxPercentage: number = 0;

  submitted = false;
  loading = false;
  exLoaded = false;

  constructor(
    protected ref: NbDialogRef<DialogDoExerciseComponent>,
    private exerciseService: ExerciseService
  ) {}

  ngOnInit() {
    if (this.linkExerciseId) this.loadExercise(this.linkExerciseId);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    if (this.exercise) {
      const value = this.exercise.percentCompleted
        ? this.maxPercentage >= this.exercise.percentCompleted
        : true;

      this.ref.close(value);
    } else {
      this.ref.close();
    }
  }

  onMaxPercentage(value) {
    if (value) {
      this.maxPercentage = value;
    }
  }

  private loadExercise(id) {
    this.loading = true;

    this.exerciseService
      .getById(id)
      .then((doc) => {
        if (doc.exists) {
          this.exercise = doc.data();
          this.exercise.id = id;
          this.exercise.createdOn = convertTimestamp(doc.data().createdOn);
        }

        this.loading = false;
        this.exLoaded = true;
      })
      .catch((err) => {
        this.exercise = null;
        this.loading = false;
      });
  }
}
